import HeaderToolbar from 'src/shared/components/navigations/headerToolbar';

import PageContainer from 'src/shared/components/organisms/pageContainer';
import ToastConfigure from 'src/shared/components/organisms/toastConfigure';

import { CssBaseline, Box } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom';
import SideMenuUser from 'src/shared/components/navigations/side-menu/sideMenuUser';
import { SignalRProvider } from 'src/shared/contexts/signalRProvider';
import { HelpPanel } from 'src/modules/help/components/helpPanel';
import { HelpPanelButton } from 'src/modules/help/components/helpPanelButton';
import { showsHelpPanelButton } from 'src/modules/help/functions/getHelpModuleForPath';
import { SignalRMessageHandler } from './signalRMessageHandler';

export const UserLayout = () => {
  const { pathname } = useLocation();

  const showHelpButton = showsHelpPanelButton(pathname);

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <HeaderToolbar />
      <SideMenuUser />
      <PageContainer spaceForHelpButton={showHelpButton}>
        <SignalRProvider>
          <SignalRMessageHandler />
          <Outlet />
        </SignalRProvider>
      </PageContainer>
      {showHelpButton && <HelpPanelButton />}
      <HelpPanel />
      <ToastConfigure />
    </Box>
  );
};
